import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { AreaModel } from '../../system/area/model/area.model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { VersionUpdaterService } from './version-updater.service';
import { AssignShopsComponent } from './assign-shops/assign-shops.component';
import { EditVersionUpdaterComponent } from './edit-version-updater/edit-version-updater.component';


@Component({
  selector: 'app-version-updater',
  templateUrl: './version-updater.component.html',
  styleUrl: './version-updater.component.scss',
  standalone: false
})
export class VersionUpdaterComponent {
  versionList: any[] = [];

  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [
    {
      title: "Version",
      column: "hdr.path",
    },
    {
      title: "Folder",
      column: "hdr.path",
    },
    {
      title: "Critical",
      column: "hdr.is_critical",
    },
    {
      title: "Assign Shops",
      column: "shop_count",
    }
  ];
  displayedColumns = ['item', 'version', 'folder', 'critical', 'assignShops', 'edit', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: any;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<any>(true, []);
  dataSource = new MatTableDataSource(this.versionList);
  IsDownloading: boolean = false;
  private isInitializing: boolean = true; // Flag to prevent multiple API calls during initialization

  constructor(private breakpointObserver: BreakpointObserver,
    private versionUpdaterService: VersionUpdaterService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router, private stateManagerService: StateManagerService,
  ) {

    this.versionList = [];
  }
  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    this.isLoading = false; // Set to true on page load
    // Remove this loadData() call as it will be handled by ngAfterViewInit -> loadPreviousState
    // this.loadData();
  }
  /** 
   * Set the datasource
   */
  setDataSource(versionList: any[]) {
    this.dataSource = new MatTableDataSource(versionList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    // this.loadData();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

      // Load data once with the restored state
      this.loadData();

    } else {
      this.setSortColumn('name', 'asc');
      this.loadData();
    }

    // Set initialization flag to false after initial setup
    this.isInitializing = false;

  }
  /**
   * Maps display column names to API column names
   * @param column 
   * @returns API column name
   */
  mapColumnToApiField(column: string): string {
    const columnMapping: { [key: string]: string } = {
      'version': 'hdr.path',
      'folder': 'hdr.path',
      'critical': 'hdr.is_critical',
      'assignShops': 'shop_count',
      'item': 'hdr.hdr_id'
    };

    return columnMapping[column] || column;
  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    const apiColumn = this.mapColumnToApiField(column);
    this.columnSortData.push({ column: apiColumn, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.versionList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.versionList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: searchParam.advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    // Prevent API call during initialization
    if (this.isInitializing) {
      this.searchColumFilter = columFilter;
      return;
    }

    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(areaInfo: AreaModel): void {
    // const areaId = areaInfo.id;
    // const message = `Are you sure, you want to delete ` + (areaInfo.name + "?");
    // const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    // const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    //   maxWidth: "400px",
    //   data: dialogData
    // });

    // dialogRef.afterClosed().subscribe(dialogResult => {
    //   console.log(dialogResult);
    //   if (dialogResult) {
    //     this.versionUpdaterService.delete(areaInfo).subscribe({
    //       next: (response) => {
    //         if (response.status == 'SUCCESS') {
    //           // handle success
    //           let snckBarData: SnackBarData = {
    //             type: 'success',
    //             title: 'Saved',
    //             message: 'The record for ' + areaInfo.name + " has been deleted succesfully."
    //           }
    //           this.snackBarService.openSnackBar(snckBarData);
    //           this.loadData();
    //         } else {
    //           let snackBarData: SnackBarData = {
    //             message: response.message,
    //             title: 'Failed!!!',
    //             type: 'error'
    //           }
    //           this.snackBarService.openSnackBar(snackBarData);
    //         }
    //       },
    //       error: (error) => {
    //         let snackBarData: SnackBarData = {
    //           message: 'Failed to update. Connection to the server failed',
    //           title: 'Failed!!!',
    //           type: 'error'
    //         }
    //         this.snackBarService.openSnackBar(snackBarData);
    //       }
    //     });
    //   }
    // });
  }

  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();

    this.versionUpdaterService.getVersionList(requestData).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          // Transform API response to match component expectations
          this.versionList = response.data.versions.map((version: any) => ({
            id: version.hdr_id,
            major: version.major,
            minor: version.minor,
            patch: version.patch,
            version: `${version.major}.${version.minor}.${version.patch}`,
            folder: version.path,
            critical: version.is_critical === '1',
            description: version.description,
            date: version.date,
            isPublished: version.is_published === '1',
            assignedShops: parseInt(version.shop_count || '0'),
            shopCode: version.shop_code,
            stationList: version.station_list,
            lastUpdateStatus: version.last_update_status,
            lastUpdateDate: version.last_update_date,
            lastUpdateMessage: version.last_update_message
          }));

          this.setDataSource(this.versionList);
          this.pagingData.length = response.data.total_count;

          if (this.pagingData.length === 0) {
            let snackBarData: SnackBarData = {
              message: 'No data found. Please remove or change the filter if any.',
              title: 'No Data!!!',
              type: 'warn'
            };
            this.snackBarService.openSnackBar(snackBarData);
            this.selectedItem = undefined;
          } else {
            this.onRowSelected(this.versionList[0]);
            this.stateManagerService.setState(this.constructor.name, requestData);
          }
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to connect to server',
          title: 'Connection Error',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
        console.error('Error loading version data:', error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  /**
  * On areainfo selected
  * @param areaInfo 
  */
  onRowSelected(areaInfo: AreaModel): void {
    this.selectedItem = areaInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    // Prevent API call during initialization
    if (this.isInitializing) {
      return;
    }

    var sd = this.sort;
    this.columnSortData.length = 0;
    const apiColumn = this.mapColumnToApiField(sd.active);
    this.columnSortData.push({ column: apiColumn, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(areaInfo: AreaModel): void {

    this.router.navigate(['area-edit', areaInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new version
   */
  addClicked(): void {
    console.log('Opening add new version dialog');

    const dialogRef = this.dialog.open(EditVersionUpdaterComponent, {
      width: '600px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: {
        isEdit: false
      },
      panelClass: 'version-edit-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Edit version dialog closed:', result);
      if (result?.saved) {
        // Handle successful save
        let snackBarData: SnackBarData = {
          message: 'Version added successfully',
          title: 'Success',
          type: 'success'
        };
        this.snackBarService.openSnackBar(snackBarData);

        // Reload the version list
        this.loadData();
      }
    });
  }

  exportClicked() {
    // this.isLoading = true;
    // let requestData = this.buildRequestData();
    // this.IsDownloading = true;
    // this.versionUpdaterService.downloadExcel(requestData)
    //   .subscribe({
    //     next: blob => {
    //       // Download logic
    //       this.IsDownloading = false;
    //       const url = window.URL.createObjectURL(blob);
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.download = 'region_list.csv'; // Adjust filename if needed
    //       link.click();
    //       window.URL.revokeObjectURL(url);
    //       this.isLoading = false;


    //     },
    //     error: error => {
    //       // Handle errors
    //       this.IsDownloading = false;
    //       let snackBarData: SnackBarData = {
    //         message: 'Failed to update. Connection to the server failed',
    //         title: 'Failed!!!',
    //         type: 'error'
    //       }
    //       this.snackBarService.openSnackBar(snackBarData);
    //       this.isLoading = false;
    //       // Display user-friendly error message to the user
    //     }
    //   }
    //   );
  }

  /**
   * Handle view shops action
   */
  onViewShops(version: any): void {
    // Navigate to version updated shop list component with version string as updatedVersion parameter
    this.router.navigate(['utilities/updated-shop-list', version.version]);
  }

  onAssignedShop(version: any): void {
    console.log('Opening edit version dialog for:', version);

    const dialogRef = this.dialog.open(EditVersionUpdaterComponent, {
      width: '600px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: {
        version: version,
        isEdit: true
      },
      panelClass: 'version-edit-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Edit version dialog closed:', result);
      if (result?.saved) {
        // Handle successful save
        let snackBarData: SnackBarData = {
          message: 'Version updated successfully',
          title: 'Success',
          type: 'success'
        };
        this.snackBarService.openSnackBar(snackBarData);

        // Reload the version list
        this.loadData();
      }
    });
  }

  onShopsUpdate(version: any): void {
    console.log('Opening assign shops dialog for version:', version);

    // Show loading state
    this.isLoading = true;

    // Get the version number
    const versionNumber = `${version.major}.${version.minor}.${version.patch}`;

    // Make API call to get assigned shops for this version
    this.versionUpdaterService.getAssignedShopsForVersion(versionNumber).subscribe({
      next: (assignedShopsData) => {
        this.isLoading = false;
        console.log('Assigned shops data for version', versionNumber, ':', assignedShopsData);

        // Open the assign shops dialog with version and assigned shops data
        const dialogRef = this.dialog.open(AssignShopsComponent, {
          data: {
            versionId: version.version,
            version: version,
            versionNumber: versionNumber,
            assignedShops: assignedShopsData
          },
          width: '80%',
          maxWidth: '1200px',
          maxHeight: '90vh',
          panelClass: 'assign-shops-dialog'
        });

        // Handle dialog result
        dialogRef.afterClosed().subscribe(result => {
          if (result && result.assigned) {
            console.log('Shops assigned:', result);

            // Show success message
            let snackBarData: SnackBarData = {
              message: result.message || 'Shops assigned successfully',
              title: 'Success',
              type: 'success'
            };
            this.snackBarService.openSnackBar(snackBarData);

            // Reload the version data to reflect changes
            this.loadData();
          }
        });
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error getting assigned shops for version:', error);

        // Show error message
        let snackBarData: SnackBarData = {
          message: 'Error loading assigned shops data',
          title: 'Error',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);

        // Still open the dialog even if API call fails
        const dialogRef = this.dialog.open(AssignShopsComponent, {
          data: {
            versionId: version.version,
            version: version,
            versionNumber: versionNumber,
            assignedShops: null
          },
          width: '80%',
          maxWidth: '1200px',
          maxHeight: '90vh',
          panelClass: 'assign-shops-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result && result.assigned) {
            console.log('Shops assigned:', result);

            let snackBarData: SnackBarData = {
              message: result.message || 'Shops assigned successfully',
              title: 'Success',
              type: 'success'
            };
            this.snackBarService.openSnackBar(snackBarData);

            this.loadData();
          }
        });
      }
    });
  }
  /**
   * Handle deploy action
   */
  onDeploy(version: any): void {
    const dialogData = new ConfirmDialogModel(
      'Confirm Deployment',
      `Are you sure you want to deploy version ${version.version}?`
    );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.deployVersion(version);
      }
    });
  }

  /**
   * Deploy version
   */
  private deployVersion(version: any): void {
    this.isLoading = true;

    // Call deployment service
    const snackBarData: SnackBarData = {
      message: `Version ${version.version} deployment started successfully`,
      title: 'Deployment Started',
      type: 'success'
    };
    this.snackBarService.openSnackBar(snackBarData);
    this.isLoading = false;

    // Refresh data after deployment
    // this.loadData();
  }

}
